import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    width: 300px;
    @media (max-width: 768px) {
      width: 200px;
    }
  }

  h1 {
    margin-bottom: 54px;
    font-size: 18px;
    text-align: center;

    @media (max-width: 480px) {
      font-size: 16px;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 340px;
    margin-bottom: 64px;

    button {
      margin-top: 16px;
      width: 100%;
      font-size: 16px;
      height: 56px;
      margin-bottom: 28px;
    }

    @media (max-width: 480px) {
      max-width: 80vw;
    }

    > span {
      font-size: 14px;
      text-align: center;

      > a {
        text-decoration: none;
        font-weight: bold;
        color: #000;

        &:hover {
          cursor: pointer;
        }
      }

      @media (max-width: 480px) {
        font-size: 12px;
      }
    }
  }
`;
